export const AppConfig = {
  appUrl: 'https://hqgrrfljueqssrn.form.io',
  apiUrl: 'https://api.form.io'
};
